import { Button, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, SectionContainer } from "@repo/ui";

interface SectionFooterProps {
  visibleCount: number;
  totalCount: number;
  isShowAll: boolean;
  onToggle: () => void;
  showToggle?: boolean;
}

export const ShowMoreFooter = ({
  visibleCount,
  totalCount,
  isShowAll,
  onToggle,
  showToggle = true,
}: SectionFooterProps) => {
  return (
    <SectionContainer>
      <FlexDiv alignItems="center" justifyContent="center" gap="6px">
        <Text textStyle="Body.S">
          {t("action.show_result", {
            currentNumber: visibleCount,
            totalNumber: totalCount,
          })}
        </Text>
        {showToggle && (
          <Button
            text={isShowAll ? t("action.view_less") : t("action.view_all")}
            type="secondary"
            size="xsmall"
            onClick={onToggle}
          />
        )}
      </FlexDiv>
    </SectionContainer>
  );
};
